export interface Payload {
	clientId: string;
	name: string;
	document: string;
	typePerson: "physical" | "legal";
	sex: string;
	birthDate: string;
	status: "pending";
	employmentRelationShip: string;
	motherName: string;
	maritalStatus: string;
	email: string;
	phone: string;
	rentMonthsCount: string;
	rentalCost: "only_rent";
	sendSerasa: "not_send_serasa";
	sendClick: "send";
	propertyFinally: string;
	isTipping: "0";
	propertyType: string;
	addressZipcode: string;
	addressStreet: string;
	addressNumber: string;
	addressComplement: string;
	addressDistrict: string;
	addressCity: string;
	addressState: string;
	addressIBGE: string;
	serasaResponse: string;
	serasaAnalysisStatus: string;
	paymentMethod: "billet";
	contractBegin: string | null;
	contractEnd: string | null;
	rentAmount: string;
	condominiumAmount: string;
	electricEnergyAmount: string;
	waterAmount: string;
	gasAmount: string;
	iptuAmount: string;
	createdFrom: "web_app";
	assuranceMonthAmount: string;
	lmi: string;
	lmiAmount: string;
	relation: string; // JSON string
	planlist: string;
	isContractRunner: "0";
	id: string;
}

export interface RowData {
	cpf: string;
	nome: string;
	status?: string;
	mensagem?: string;
	[key: string]: any;
}

export interface PeopleData {
	document: string;
	personType: "natural" | "legal";
	legalPersonData: any;
	naturalPersonData: {
		motherName: string;
		name: string;
		birthDate: string;
	};
}

export interface AddressData {
	addressZipcode: string;
	addressStreet: string;
	addressDistrict: string;
	addressCity: string;
	addressState: string;
	addressComplement: string;
	addressIBGE: string;
}

export const headers = [
	"imobiliaria",
	"cnpjimobiliaria",
	"cpf",
	"nome",
	"telefone",
	"email",
	"locacao",
	"tipodeimovel",
	"endereco",
	"numero",
	"complemento",
	"bairro",
	"cidade",
	"estado",
	"cep",
	"documentolocador",
	"nomelocador",
	"iniciogarantia",
	"fimgarantia",
	"taxa",
	"aluguel",
	"condominio",
];

export const REQUIRED_HEADERS = {
	cpf: ["cpf", "cpf locatario", "cpf do cliente", "cpf/cnpj locatario"],
	nome: ["nome", "nome locatario"],
	cep: ["cep", "código postal"],
	endereco: ["endereco", "endereço", "logradouro", "endereço"],
	numero: ["numero", "número"],
	bairro: ["bairro"],
	cidade: ["cidade", "municipio"],
	estado: ["estado", "uf"],
	email: ["email", "e-mail", "email locatario", "email do cliente"],
	telefone: ["telefone", "celular", "contato", "telefone locatario", "telefone do cliente"],

	//iniciogarantia: ["iniciodagarantia", "data de início da garantia", "Inicio da Garantia"],
	//fimgarantia: ["fimdagarantia", "data de fim da garantia", "Fim da Garantia"],
};

export const REQUIRED_HEADERS_CERTIFICATE = {
	cpf: ["cpf", "documento", "cpf locatario", "cpf/cnpj"],
};

export interface RowDataCertificate {
	RowNumber: number;
	cpf: string;
	status: "pendente" | "invalido" | "buscando" | "nao_encontrado" | "multiplas" | "enviado" | "erro";
	mensagem: string;
	proposalIds?: string[];
}

export const REQUIRED_HEADERS_REPASSE = {
	certificado: ["certificado", "número do certificado", "número do contrato"],
	valor: ["valor", "valor do repasse", "valor do contrato"],
	tipo: ["tipo", "tipo de repasse", "tipo do comissionamento"],
	vencimento: ["vencimento", "vencimento do repasse", "data de vencimento"],
	cnpjImobiliaria: ["cnpj imobiliaria", "cnpj da imobiliária", "imobiliária", "cnpj"],
};

export const headersRepasses = ["Imobiliaria", "certificado", "valor", "tipo", "vencimento", "status"];

export interface RepasseData {
	certificado: string;
	valor: string; // Mantemos como string inicialmente, pois vem do CSV e é processado
	tipo: string;
	vencimento: string; // Mantemos como string, pois é processado
	cnpjImobiliaria: string;
	[key: string]: any; // Permite outros campos que não estejam explicitamente listados
}

// 2. Tipagem dos Dados de Linha (após importação e análise)
// Esta é a RowDataRepasse, que é o objeto que o componente RepassesTab manipula.
export interface RowDataRepasse extends RepasseData {
	// Campos de Metadados de Processamento
	status: "importado" | "validado" | "inválido";
	mensagem: string;
	RowNumber: number;

	// [key: string]: any; // Já herdado do RepasseData
}

export interface CommissionDetail {
	proposalCertificateNumber: number; // Certificado
	value: string; // Valor
	type: string; // Tipo
	// ... outros campos (dueDate, status, etc.)
	[key: string]: any;
}

export interface RowDataRepasse {
	// ... campos existentes ...
	idComissao?: string | null; // Guardará o clientId da primeira chamada
	commissionDetails?: CommissionDetail[] | null; // NOVO: Detalhes da comissão
	// ...
}
